import { motion, useAnimation } from 'framer-motion';
import { useEffect, useState } from 'react';
import fundoRodape from '@/assets/fundo-rodape.png';

const ImagemFlutuante = () => {
  const controls = useAnimation();
  const [visivel, setVisivel] = useState(true);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    const imagemWidth = 300; // ajuste se necessário
    const duracao = 6; // em segundos

    controls.start({
      x: [-(imagemWidth + 100), screenWidth / 2 - imagemWidth / 2, screenWidth + 100],
      transition: { duration: duracao, ease: 'easeInOut' },
    });

    // Oculta o container após o tempo da animação
    const timer = setTimeout(() => setVisivel(false), duracao * 1000);

    return () => clearTimeout(timer);
  }, [controls]);

  if (!visivel) return null;

  return (
    <div className="relative w-full h-48 overflow-hidden">
      <motion.img
        src={fundoRodape}
        alt="Fundo Rodapé"
        className="absolute top-0 h-48 object-contain"
        animate={controls}
      />
    </div>
  );
};

export default ImagemFlutuante;
